<template>
  <div class="member-area-management">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>人员负责区域管理</span>
        <el-button
          class="tz-r tz-create-btn"
          round
          type="primary"
          @click="handleAdd"
          >新增</el-button
        >
      </div>
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="人员姓名">
          <el-input
            v-model="searchForm.personName"
            placeholder="请输入人员姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
          <!-- <el-button type="danger" @click="handleRefresh">刷新缓存</el-button> -->
        </el-form-item>
      </el-form>

      <!-- 使用自定义表格组件 TzTable -->
      <TzTable :tableData="tableData" :columns="columns" />

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
      >
      </el-pagination>
    </el-card>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form" label-width="120px">
        <el-form-item label="人员" prop="personId">
          <el-select
            v-model="form.personId"
            placeholder="请选择人员"
            filterable
            @change="handlePersonChange"
          >
            <el-option
              v-for="item in membersList"
              :key="item.id"
              :label="item.personName"
              :value="item.personId"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="form.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <!-- <el-form-item label="负责时间" prop="responsibleTime">
          <el-input
            v-model="form.responsibleTime"
            placeholder="请输入负责时间"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="开始日期" prop="startTime">
          <el-date-picker
            v-model="form.startTime"
            type="date"
            placeholder="选择开始日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期" prop="endTime">
          <el-date-picker
            v-model="form.endTime"
            type="date"
            placeholder="选择结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item> -->
        <el-form-item label="负责区域" prop="areaNames">
          <el-input
            type="textarea"
            v-model="form.areaNames"
            placeholder="请输入负责区域"
          ></el-input>
          <!-- <el-select
            v-model="form.areaIds"
            multiple
            placeholder="请选择区域"
            filterable
          >
            <el-option
              v-for="item in areaOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import TzTable from '@/components/tz-table/Index.vue'

// 导入 API 函数（请根据实际路径确认）
import {
  getPageList,
  getMembersList,
  deleteMemberArea,
  saveMemberArea,
  updateMemberArea,
  refreshAreaContactCache
} from '@/api/personArea'

export default {
  name: 'MemberAreaManagement',
  components: {
    TzTable
  },
  data() {
    return {
      searchForm: {
        personName: ''
      },
      // 表格列配置
      columns: [
        { title: '人员姓名', field: 'personName' },
        { title: '手机号', field: 'phone' },
        // { title: '负责时间', field: 'responsibleTime' },
        { title: '负责区域', field: 'areaNames' }, // 修正为 areaNames 以正确显示区域名称
        // {
        //   title: '开始日期',
        //   field: 'startTime',
        //   // 使用 formatter 格式化时间（假设 TzTable 支持该属性）
        //   formatter: (row) => this.formatDate(row.startTime)
        // },
        // {
        //   title: '结束日期',
        //   field: 'endTime',
        //   formatter: (row) => this.formatDate(row.endTime)
        // },
        {
          title: '操作',
          width: '160',
          type: 'btn',
          payload: [
            {
              name: '编辑',
              type: 'primary',
              click: (row) => this.handleEdit(row)
            },
            {
              name: '删除',
              type: 'danger',
              click: (row) => this.handleDelete(row) // 修正为 handleDelete
            }
          ]
        }
      ],
      tableData: [],
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: '',
        personId: '',
        personName: '',
        phone: '',
        responsibleTime: '',
        startTime: '',
        endTime: '',
        // areaIds: [],
        areaNames: ''
      },
      rules: {
        personId: [
          { required: true, message: '请选择人员', trigger: 'change' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            validator: this.checkMobilePhone,
            trigger: 'blur'
          }
        ],
        // responsibleTime: [
        //   { required: true, message: '请输入负责时间', trigger: 'blur' }
        // ],
        // startTime: [
        //   { required: true, message: '请选择开始日期', trigger: 'change' }
        // ],
        // endTime: [
        //   { required: true, message: '请选择结束日期', trigger: 'change' }
        // ],
        areaNames: [
          { required: true, message: '请选择负责区域', trigger: 'change' }
        ]
      },
      membersList: [],
      areaOptions: [
        { value: '1', label: '区域A' },
        { value: '2', label: '区域B' },
        { value: '3', label: '区域C' }
      ]
    }
  },
  created() {
    this.loadData()
    this.loadMembersList()
  },
  methods: {
    // 加载表格数据（替换 this.$http）
    loadData() {
      getPageList({
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        personName: this.searchForm.personName
      }).then((response) => {
        this.tableData = response.data.records
        this.pagination.total = response.data.total
      })
    },
    // 加载人员列表（替换 this.$http）
    loadMembersList() {
      getMembersList().then((response) => {
        this.membersList = response.data
      })
    },
    handleSearch() {
      this.pagination.pageNum = 1
      this.loadData()
    },
    handleReset() {
      this.searchForm.personName = ''
      this.handleSearch()
    },
    handleRefresh() {
      this.$confirm('确认刷新缓存吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        refreshAreaContactCache().then(() => {
          this.$message.success('刷新成功')
          this.handleSearch()
        })
      })
    },
    handleAdd() {
      this.dialogTitle = '新增'
      this.form = {
        id: '',
        personId: '',
        personName: '',
        phone: '',
        responsibleTime: '',
        // startTime: '',
        // endTime: '',
        // areaIds: [],
        areaNames: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    handleEdit(row) {
      this.dialogTitle = '编辑'
      this.form = {
        id: row.id,
        personId: row.personId,
        personName: row.personName,
        phone: row.phone,
        responsibleTime: row.responsibleTime,
        // startTime: row.startTime,
        // endTime: row.endTime,
        // areaIds: row.areaIds ? row.areaIds.split(',') : [],
        areaNames: row.areaNames
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.form.clearValidate()
      })
    },
    async checkMobilePhone(rule, value, callback) {
      if (!/^1\d{10}$/.test(value)) return callback('手机号格式有误')
    },
    // 删除操作（替换 this.$http）
    handleDelete(row) {
      this.$confirm('确认删除该记录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteMemberArea({ id: row.id }).then(() => {
          this.$message.success('删除成功')
          this.loadData()
        })
      })
    },
    handlePersonChange(value) {
      const member = this.membersList.find((item) => item.personId === value)
      if (member) {
        this.form.personName = member.personName
        this.form.phone = member.phone
      }
    },
    // 提交表单（替换 this.$http）
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          //   const areaNames = this.form.areaIds
          //     .map((id) => {
          //       const area = this.areaOptions.find((item) => item.value === id)
          //       return area ? area.label : ''
          //     })
          //     .join(',')
          //   const data = {
          // ...this.form,
          // areaIds: this.form.areaIds.join(','),
          // areaNames: areaNames
          //   }
          // 根据是否有 id 选择新增或更新接口
          const apiCall = this.form.id ? updateMemberArea : saveMemberArea
          apiCall(this.form).then((res) => {
            if (res.code == 200) {
              this.$message.success(this.form.id ? '更新成功' : '保存成功')
              this.dialogVisible = false
              this.loadData()
            } else {
              this.$message({
                message: res.data,
                type: 'error'
              })
            }
          })
        }
      })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.loadData()
    },
    handleCurrentChange(val) {
      this.pagination.pageNum = val
      this.loadData()
    },
    // 日期格式化方法
    formatDate(date) {
      if (!date) return ''
      return new Date(date).toLocaleString('zh-CN')
    }
  }
}
</script>

<style scoped>
.member-area-management {
  padding: 20px;
}
.search-form {
  margin-bottom: 20px;
}
.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>
